import script from "./OEditarGrupos.vue?vue&type=script&setup=true&lang=ts"
export * from "./OEditarGrupos.vue?vue&type=script&setup=true&lang=ts"

import "./OEditarGrupos.vue?vue&type=style&index=0&id=2b0a7399&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b0a7399"]])

export default __exports__